import {Navigate} from 'react-router-dom';
import {useIdleTimer} from 'react-idle-timer';
import {endKeycloakSession} from './signOut';
import {isAuthenticated} from './sessionStore';
import {getEnv} from '../../getEnv';

const DEFAULT_IDLE_TIMEOUT_MS = 15 * 60 * 1000; // 15 minutes

export const PrivateRoute = ({ element, redirectPath = '/signin' }) => {
  const env = getEnv();
  const authenticated = isAuthenticated();

  // env values often arrive as strings - coerce, and fall back if missing/invalid
  const envTimeout = Number(env?.idle_timeout);
  const idleTimeout = Number.isFinite(envTimeout) && envTimeout > 0
    ? envTimeout
    : DEFAULT_IDLE_TIMEOUT_MS;

  const onIdle = async () => {
    await endKeycloakSession('idle timeout');
  };
  
  useIdleTimer({
    onIdle,
    timeout: idleTimeout, // ms
    events: [
      'mousemove',
      'keydown',
      'wheel',
      'DOMMouseScroll',
      'mousewheel',
      'mousedown',
      'touchstart',
      'touchmove',
      'MSPointerDown',
      'MSPointerMove',
      'visibilitychange'
    ],
    eventsThrottle: 200,
    stopOnIdle: true, //stop the timer so it doesn't loop,
    capture: true, //in capture phase, before stopPropagation can block (modal, offcanvas, inputs)
    passive: true
  });

  if (!authenticated) {
    return <Navigate to={redirectPath} replace />;
  }

  return element
}

export default PrivateRoute;
